export const LOG_IN = 'auth/login';
export const LOG_OUT = 'auth/logout';
export const AUTH_CURRENT = 'auth/current';
export const UPDATE_PROFILE = 'auth/updateProfile';
